import uuid from "uuid";
import $ from "jquery";

import COLOR_THEMES from "../../../store/colorThemes";
import Config from "../../../store/sqftConfig";
import {
  getAngleBetweenTwoPoints,
  getMidPoint, getMinInArray, getParallelPoints,
  getPointDistance, getPointField, getSectionPartPoint, isDisabledInPopupWithParents,
  measureDistanceToInches, numToLetter,
  orientation
} from "../../../../../helpers/sqftHelper";
import point from "../point";
import EventManager from "../../../store/sqftEventManager";
import workspace from "../../workspace";
//import TranslatesProvider from "../../../../../translatesProvider";
import MiteredSegment from "../shapeParts/mitered/miteredSegment";
import NumberText from "../../workspace/text/numberText";
import DrawImage from "../../workspace/textBox/draw/drawImage";
import store from "../../../../../../../store";
import sqftConfig from "../../../store/sqftConfig";
import {
  isDisabledInPopupShouldBeHidden, MITERED_OVERLAY_TYPE,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_NAVIGATION_BUTTONS
} from "../../../../../constants";
import RenderFigures from "../../../helpers/renderFigures";
import sqftSlabManager from "../../../store/sqftSlabManager";
import {getQtCatName} from "../../../../../helpers/sqftQuotesHelper";
import {setLineWidth} from "../../../helpers/lineHelper";
import {getMaxResizeWidth} from "./resizeLine";

export default class MiteredOverlay {
  id;
  sectionIndex;
  line;
  self = this;
  qtCatName = null;
  featureId = null;
  type = null; //mitered || underlayment
  state = {
    mousePos: {},
    mouseDown: false,
    mouseDownPosition: null,
    isHoveringPoint: false,
    hoveredPoint: null,
    isHoveredOverText: false,
    hoveredText: {
      area:[],
      midPoint: {x: 0, y: 0},
      pointsDistance: 0,
      points: {point1: null, point2: null},
      orientation: 0
    },
    midPoint: {
      x: 0,
      y: 0,
    },
    height: 1.5,
    heightMetric: 40,
    thickness: 4,
    thicknessMetric: 40,
    maxSegmentPriority: 0
  };
  design = {
    //initialSize: 30,
    minMiteredSize: 1,
    measurementMargin: 30, //11,
    dragPointMargin: 28,
    rulerMargin: 33,
    heightMargin: 60,
    sectionIndexMargin: 95,
    sectionArrowWidth: 30,
    letterMargin: 18,
    thicknessMargin: -18,
    movePointOffset: 15,
    lineTextColor: COLOR_THEMES[Config.activeTheme].primary,
    fontColor: COLOR_THEMES[Config.activeTheme].primary,
    deleteFillStyle: "#e77f8d", //"rgba(253,2,33, 0.5)",
    fontFamily: 'playbold',
    fontHeight: 16
  };
  miteredPoints = []; // array of points
  _segments = []; // array of MiteredSegments
  miteredTextParameters = []; //array of objects
  heightNumberText = {}; //array of objects
  isResizingParentLine = false;

  constructor(line, sectionIndex, type) {
    this.line = line;
    this.sectionIndex = sectionIndex;
    this.type = type;
    this.id = uuid();
    this.qtCatName = getQtCatName();
  }

  setMiteredPoints = (value) => { this.miteredPoints = value; }
  getSegments = () => { return this._segments; }
  getParent = () => { return this.line; }
  setSegments = (value) => { this._segments = value; }
  setFeatureId = (value) => { this.featureId = value; }

  movePointInOrStop = (point1, axis, diff, biggestLineCord, smallestLineCord, stopPointLeft, stopPointRight, moveStopPoints) => {
    //stop on other move points
    let smallestPointStopped = null;
    let biggestPointStopped = null;
    if (point1[axis] - diff < stopPointLeft[axis]) {
      smallestLineCord = stopPointLeft[axis] + this.design.minMiteredSize;
      smallestPointStopped = stopPointLeft;
      if(moveStopPoints) {
        let lengthDiff = point1[axis] - stopPointLeft[axis] - diff;
        this.movePoint(-lengthDiff, point1[axis] - diff, stopPointLeft, true);
        this.moveMeasurements(stopPointLeft);
        smallestLineCord = stopPointLeft[axis];
      }
    } else if (point1[axis] - diff > stopPointRight[axis]) {
      biggestLineCord = stopPointRight[axis] - this.design.minMiteredSize;
      biggestPointStopped = stopPointRight;
      if(moveStopPoints) {
        let lengthDiff = point1[axis] - stopPointRight[axis] -  diff;
        this.movePoint(-lengthDiff, lengthDiff, stopPointRight, true);
        this.moveMeasurements(stopPointRight);
        biggestLineCord = stopPointRight[axis];
      }
    }

    // keep inside line
    if (point1[axis] - diff >= biggestLineCord) {
      point1[axis] = biggestLineCord;
    } else if (point1[axis] - diff <= smallestLineCord) {
      point1[axis] = smallestLineCord;
    } else {
      point1[axis] -= diff;
    }

    return [smallestPointStopped, biggestPointStopped]
  };

  getMousePosPointDiff = (diff, point, mousePos, sameOrientation = false) => {
    if(Config.measureUnit === "Metric") {
      let offset = 0;
      switch(this.line.getOrientation()) {
        case orientation.HORIZONTAL:
          offset = sameOrientation ? mousePos.x - point.getPointField().x : mousePos.y - point.getPointField().y;
          break;
        case orientation.VERTICAL:
          offset = sameOrientation? mousePos.y - point.getPointField().y : mousePos.x - point.getPointField().x;
          break;
        case orientation.NORTHWEST:
        case orientation.SOUTHEAST:
          break;
        case orientation.NORTHEAST:
        case orientation.SOUTHWEST:
          break;
      }
      if(!(-this.design.movePointOffset / 2 > offset || offset > 3 * this.design.movePointOffset)) {
        diff = diff / Config.millimetersMultiplier;
      }
    }

    return diff
  };

  getPoints = () => { return this.miteredPoints; };
  getMiteredTextParameter = () => { return this.miteredTextParameters; };
  isMiteredPointMoving = () => { return this.state.mouseDown};

  destroy = (protect) => {
    if(!protect) {
      EventManager.removeEvent(this);
      this.miteredPoints.forEach((point) => point.destroy());
      this._segments.forEach((segment) => {
        segment.length.destroy();
        if (segment.thickness) {
          segment.thickness.destroy();
        }
      });
      this.heightNumberText.destroy();

      if (this.type === MITERED_OVERLAY_TYPE.mitered) {
        workspace.miteredController.deleteSection(this);
      } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
        workspace.underlaymentController.deleteSection(this);
      }
    }
  };

  init = (importData = null) => {
    if (this.line.overlay) {
      this.line.overlay.destroy();
    }
    if(!importData) {
      this.preparePoints(false);
    }
    this.prepareMeasurements(importData);
    this.prepareHeight(importData);
    this.initEvents();

    //points
    this.miteredPoints.forEach((point, index) => {
      if (index === 0 || index === this.miteredPoints.length - 1) {
        this.initPoint(point, 'blank');
      } else {
        this.initPoint(point, 'white-circle');
      }
    });

    // todo fix bumpout rotation and remove this
    $('.button--angle').addClass('button--disabled');
    /////////////////////////////////////////
  };
  initEvents = () => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.SEGMENT
    );
    //todo priority
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_LEAVE,
      this.onMouseLeave,
      this,
      EventManager.priorities.OVERALL
    );
  };
  deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.heightNumberText.deregisterEvents();
    for (let segment of this._segments ) {
      segment.length.deregisterEvents();
      if (segment.thickness) {
        segment.thickness.deregisterEvents();
      }
    }
  };
  reInitEvents = () => {
    this.initEvents();
    this.heightNumberText.reInitEvents();
    for (let segment of this._segments ) {
      segment.length.reInitEvents();
      if (segment.thickness) {
        segment.thickness.reInitEvents();
      }
    }
  };

  getMiteredTotalArea = () => {
    let totalArea = 0,
      lineLength = Config.measureUnit === "Metric" ? this.line.getLineLengthMm() : this.line.getLineLength(),
      height = Config.measureUnit === "Metric" ? this.state.heightMetric : this.state.height;
      //segmentsLength = 0,
      //minThicknessToCount = Config.measureUnit === "Metric" ? 40 : 1;

    // for (let segment of this._segments) {
    //   if (segment instanceof MiteredSegment) {
    //     if(segment.thickness.value >= minThicknessToCount ) {
    //       let segmentLength = Config.measureUnit === "Metric"
    //         ? inchesToMm(segment.length.value)
    //         : this.line.addDecimalToLength(measureDistanceToInches(segment.length.value));
    //
    //       segmentsLength += +segment.thickness.value + +segmentLength
    //     }
    //   }
    // }

    //totalArea = height * (lineLength + segmentsLength);
    totalArea = height * (lineLength);

    return totalArea;
  };

  export = () => {
    return {
      miteredPoints : this.miteredPoints.map((point) => {
        return point.export();
      }),
      state: this.state,
      _segments: this._segments.map((segment) => {
        return segment.exportSegment()
      }),
    }
  };

  import = (line, importMitered) => {
    for (const importPoint of importMitered.miteredPoints) {
      const preparePoint = new point();
      preparePoint.import(importPoint);

      this.miteredPoints.push(preparePoint);
    }
    this.state = importMitered.state;
    this.state = importMitered.state;
  };

  preparePoints = (shouldAddTwoPointsInTheMiddle = false) => {
    let point33 = getSectionPartPoint(this.line.from, this.line.to, 2),
      point66 = getSectionPartPoint(this.line.from, this.line.to, 1/2);
    let [fromPointWithIndent, toPointWithIndent] = this.line.getLinePointsWithoutCorners();
    const miteredPoints = [
      new point(fromPointWithIndent.x, fromPointWithIndent.y),
      ...(shouldAddTwoPointsInTheMiddle ? [new point(point33.x, point33.y), new point(point66.x, point66.y)] : []),
      new point(toPointWithIndent.x, toPointWithIndent.y)
    ];

    this.setMiteredPoints(miteredPoints);
  };

  prepareMeasurements = (importData = null) => {
    this.miteredPoints.forEach((point, index) => {
      let next = index + 1;
      if(this.miteredPoints[next]) {
        this.addMeasurementBetweenPoints(point, this.miteredPoints[next], importData ? importData._segments[index] : null);
      }
    });
  };

  prepareHeight = (importData = null) => {
    const midPoint = getMidPoint(this.line.from, this.line.to),
      lineDirection = this.line.getLineDirection(),
      fontHeight = this.design.fontHeight;

    let xMarginHeight = 0,
      yMarginHeight = -this.design.heightMargin - fontHeight,
      angle = getAngleBetweenTwoPoints(this.line.from, this.line.to);

    switch (lineDirection.orientation) {
      case "horizontal": {
        if (lineDirection.newDirection === "west") {
          angle += 180
          yMarginHeight = this.design.heightMargin + fontHeight;
        }
        break;
      }
      case "vertical": {
        break;
      }
      // todo rotation
      case "NORTHWEST": { break;}
      case "NORTHEAST": { break;}
      case "SOUTHWEST": { break;}
      case "SOUTHEAST": { break;}
      default:
        break;
    }

    let posHeight = {
      // betweenPoints: {
      //   pointFrom: this.line.from,
      //   pointTo:  this.line.to
      // },
      x: midPoint.x,
      y: midPoint.y,
      xOffset: xMarginHeight,
      yOffset: yMarginHeight,
      orientation: this.line.getLineDirectionV2(),
      angle: angle
    };
    let design = {
      valuePrefix: workspace.intl.formatMessage({id: "sqft.navigation.mitered.height"}) + ": ",
    };

    let heightValue =  importData
      ? importData._segments[0]
        ? importData._segments[0].height
        : null
      : Config.measureUnit === "Metric" ? this.state.heightMetric : this.state.height;

    this.heightNumberText = new NumberText(heightValue, posHeight, design, this, this.setSegmentHeightFromNumberValue);
  };

  updateMinMaxPoints = () => {
    let [fromPointWithIndent, toPointWithIndent] = this.line.getLinePointsWithoutCorners();
    // Minimum and maximum values for limiting points
    const minX = Math.min(fromPointWithIndent.x, toPointWithIndent.x);
    const minY = Math.min(fromPointWithIndent.y, toPointWithIndent.y);
    const maxX = Math.max(fromPointWithIndent.x, toPointWithIndent.x);
    const maxY = Math.max(fromPointWithIndent.y, toPointWithIndent.y);

    // Limiting points within specified boundaries
    for (const miteredPoint of this.miteredPoints) {
      miteredPoint.x = Math.max(minX, Math.min(maxX, miteredPoint.x));
      miteredPoint.y = Math.max(minY, Math.min(maxY, miteredPoint.y));
    }

    // Move the nearest points to the specified minimum and maximum values
    let startPoint = this.miteredPoints[0],
      endPoint = this.miteredPoints[this.miteredPoints.length - 1];

    startPoint.x = fromPointWithIndent.x;
    startPoint.y = fromPointWithIndent.y;
    endPoint.x = toPointWithIndent.x;
    endPoint.y = toPointWithIndent.y;

    this.updateSegmentsLength();
    this.updateSegmentThicknessPos();
  }

  addMeasurementBetweenPoints = (point1, point2, importSegment = null) => {
    let angle = getAngleBetweenTwoPoints(this.line.from, this.line.to);
    const midPoint = getMidPoint(point1, point2),
      lineDirection = this.line.getLineDirection(),
      fontHeight = this.design.fontHeight,
      // distance = Config.measureUnit === "Metric"
      //   ? distanceToMillimeters(getPointDistance(point1, point2))
      //   : getPointDistance(point1, point2)

      distance = getPointDistance(point1, point2),
      point1Index = this.miteredPoints.indexOf(point1),
      point2Index = this.miteredPoints.indexOf(point2);

    void point2Index;
    let yOffset = -this.design.measurementMargin - fontHeight,
      xOffset = 0;
      // thicknessXOffsetValue = 0,
      // xMarginLine = 0,
      // yMarginLine = 0,
      // thicknessYOffsetValue = 0;

    switch (lineDirection.orientation) {
      case "horizontal": {
        if (lineDirection.newDirection === "west") {
          angle += 180
          yOffset = this.design.heightMargin - fontHeight;
        }
        //yOffset = lineDirection.newDirection === "west" ? this.design.measurementMargin + fontHeight : -this.design.measurementMargin -fontHeight;

        // yMarginLine = (lineDirection.newDirection === "west" ? this.design.thicknessMargin : -this.design.thicknessMargin);
        //
        // thicknessXOffsetValue = (lineDirection.newDirection === "east" ? 15 : 15);
        // thicknessYOffsetValue = (lineDirection.newDirection === "east" ? 16 : -14);
        break;
      }
      case "vertical": {
        //xOffset = (lineDirection.newDirection === "south" ? this.design.measurementMargin + 10 : -this.design.measurementMargin - 10);

        // xMarginLine = (lineDirection.newDirection === "south" ? this.design.thicknessMargin: -this.design.thicknessMargin);
        //
        // thicknessXOffsetValue = (lineDirection.newDirection === "north" ? 35 : -16);
        // thicknessYOffsetValue = (lineDirection.newDirection === "north" ? 5 : 6);
        break;
      }
      //TODO rotation
      case "NORTHWEST": { break; }
      case "NORTHEAST": { break; }
      case "SOUTHWEST": { break; }
      case "SOUTHEAST": { break; }
      default: break;
    }

    let pos = {
      x: midPoint.x,
      y: midPoint.y,
      xOffset: xOffset,
      yOffset: yOffset,
      orientation: this.line.getLineDirectionV2(),
      angle: angle,
    };

    // let posThickness = {
    //   x: midPoint.x,
    //   y: midPoint.y,
    //   xOffset: thicknessXOffsetValue + xMarginLine,
    //   yOffset: thicknessYOffsetValue + yMarginLine,
    //   orientation: this.line.getLineDirectionV2()
    // };

    let design = {
      isLength: true
    };

    let lengthText = new NumberText(distance, pos, design, this, this.setSegmentLengthFromNumberValue);
    let height = importSegment
      ? importSegment.height && importSegment.height
      : Config.measureUnit === "Metric" ? this.state.heightMetric : this.state.height;
    // let thicknessValue = importSegment && importSegment.thickness
    //   ? importSegment.thickness
    //   : Config.measureUnit === "Metric" ? this.state.thicknessMetric : this.state.thickness;
    //let thickness = new NumberText(thicknessValue, posThickness, {}, this, this.setSegmentThicknessFromNumberValue);
    let segment = new MiteredSegment(lengthText, height, null);
    // todo logic combining miteredPoints and segments
    this._segments.splice(point1Index, 0, segment);
  };

  getPointDistance(point, pos) {
    let pointField = point.getPointField();

    return Math.sqrt(Math.pow(pointField.x - pos.x, 2) + Math.pow(pointField.y - pos.y, 2))
  }

  /** Returns the resize limit for a full-line section (no additional points) or the current line length for split sections. */
  getMaxLength = () => {
    if (this._segments.length === 1) {
      return Math.round(getMaxResizeWidth(this.line) * Config.getMeasureMultiplier());
    }

    return Config.measureUnit === "Metric"
      ? measureDistanceToInches(this.line.getLineLength()).millimeters // ? distanceToMillimeters(inchesToMm(segment.length.value))
      : this.line.getLineLength();
  }

  getPointBetweenCords = (mousePos) => {
    const closest = this.miteredPoints.reduce((a, b) => {
      return this.getPointDistance(a, mousePos) < this.getPointDistance(b, mousePos) ? a : b
    });
    const closestIndex = this.miteredPoints.indexOf(closest);
    let secondPoint = null;
    let isPrev = false;
    let lineDirection = this.line.getLineDirection();

    if(!this.miteredPoints[closestIndex + 1]) {
      secondPoint = this.miteredPoints[closestIndex - 1];
      isPrev = true;
    } else if(!this.miteredPoints[closestIndex - 1]) {
      secondPoint = this.miteredPoints[closestIndex + 1];
      isPrev = false;
    } else {
      let prevPoint = this.miteredPoints[closestIndex - 1];
      let nextPoint = this.miteredPoints[closestIndex + 1];
      let closestPointField = closest.getPointField();

      // todo logic
      //isPrev = this.getPointDistance(prevPoint, mousePos) < this.getPointDistance(nextPoint, mousePos);
      switch (lineDirection.orientation) {
        case "horizontal": {
          isPrev = lineDirection.newDirection === "east" ? mousePos.x < closestPointField.x : mousePos.x > closestPointField.x;
          break;
        }
        case "vertical": {
          isPrev = lineDirection.newDirection === "north" ? mousePos.y > closestPointField.y : mousePos.y < closestPointField.y;
          break;
        }
        //TODO rotation
        case "NORTHWEST": { break; }
        case "NORTHEAST": { break; }
        case "SOUTHWEST": { break; }
        case "SOUTHEAST": { break; }
        default: break;
      }

      secondPoint = isPrev ? prevPoint : nextPoint;
    }

    return [closest, secondPoint, isPrev];
  };

  addPointBetweenPoints = (closest, secondPoint, isPrev) => {
    const midPoint = getMidPoint(closest, secondPoint);
    const newPoint = new point(midPoint.x, midPoint.y);
    this.initPoint(newPoint);
    const closestIndex = this.miteredPoints.indexOf(closest);

    this.miteredPoints.splice(isPrev ? closestIndex : closestIndex + 1, 0, newPoint);

    return newPoint;
  };

  getSegmentBetweenPoints = (point1, point2) => {
    const point1Index = this.miteredPoints.indexOf(point1);
    const point2Index = this.miteredPoints.indexOf(point2);

    return this._segments[point2Index > point1Index ? point1Index : point2Index];
  };

  getSegmentPointsBySegment = (segment) => {
    const segmentIndex = this._segments.indexOf(segment);

    return [this.miteredPoints[segmentIndex], this.miteredPoints[segmentIndex + 1]];
  };

  removeMeasurementBetweenPoints = (closest, secondPoint, isPrev) => {
    const closestIndex = this.miteredPoints.indexOf(closest);
    const removeIndex = isPrev ? closestIndex - 2: closestIndex + 2;

    this._segments[removeIndex].length.destroy();
    if (this._segments[removeIndex].thickness) {
      this._segments[removeIndex].thickness.destroy();
    }
    this._segments.splice(removeIndex, 1);
  };

  deletePoint = (point) => {
    const pointIndex = this.miteredPoints.indexOf(point);

    if (pointIndex === -1) {
      return;
    }

    const isSectionEndPoint = pointIndex === 0 || pointIndex === this.miteredPoints.length - 1;
    if (isSectionEndPoint) {
      if (this.type === MITERED_OVERLAY_TYPE.mitered) {
        this.line.deleteMitered();
      } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
        this.line.deleteUnderlayment();
      }

      return;
    }

    // Replace the two segments adjacent to an internal point with one merged segment.
    this.addMeasurementBetweenPoints(this.miteredPoints[pointIndex -1], this.miteredPoints[pointIndex +1]);

    //remove previous and next segment
    this._segments[pointIndex ].length.destroy();
    this._segments[pointIndex +1].length.destroy();
    if (this._segments[pointIndex].thickness) {
      this._segments[pointIndex].thickness.destroy();
    }
    if (this._segments[pointIndex + 1].thickness) {
      this._segments[pointIndex + 1].thickness.destroy();
    }
    this._segments.splice(pointIndex, 1);
    this._segments.splice(pointIndex, 1);

    //remove point
    this.miteredPoints.splice(pointIndex, 1);

    point.destroy();
  };

  resetHoveredPoint = () => {
    this.state.hoveredPoint = null;
    this.state.mouseDown = false;
  };


  moveMeasurements = (point) => {
    const pointIndex = this.miteredPoints.indexOf(point);

    // let length = Config.measureUnit === "Metric"
    //   ? inchesToMm(getPointDistance(point, this.miteredPoints[pointIndex + 1 ]))
    //   : getPointDistance(point, this.miteredPoints[pointIndex + 1 ]);
    //
    // let length2 = Config.measureUnit === "Metric"
    //   ? inchesToMm(getPointDistance(point, this.miteredPoints[pointIndex - 1 ]))
    //   :  getPointDistance(point, this.miteredPoints[pointIndex - 1 ]);

    //move left and right measurements if they exist
    if (this.miteredPoints[pointIndex - 1 ]) {
      const midPoint2 = getMidPoint(point, this.miteredPoints[pointIndex - 1 ]);
      let length2 = getPointDistance(point, this.miteredPoints[pointIndex - 1 ]);
      this._segments[pointIndex - 1].length.pos.x = midPoint2.x;
      this._segments[pointIndex - 1].length.pos.y = midPoint2.y;
      this._segments[pointIndex - 1].length.value = length2;
      if (this._segments[pointIndex - 1].thickness) {
        this._segments[pointIndex - 1].thickness.pos.x = midPoint2.x;
        this._segments[pointIndex - 1].thickness.pos.y = midPoint2.y;
      }
    }
    if (this.miteredPoints[pointIndex + 1 ]) {
      const midPoint = getMidPoint(point, this.miteredPoints[pointIndex + 1 ]);
      let length = getPointDistance(point, this.miteredPoints[pointIndex + 1 ]);
      this._segments[pointIndex].length.pos.x = midPoint.x;
      this._segments[pointIndex].length.pos.y = midPoint.y;
      this._segments[pointIndex].length.value = length;
      if (this._segments[pointIndex].thickness) {
        this._segments[pointIndex].thickness.pos.x = midPoint.x;
        this._segments[pointIndex].thickness.pos.y = midPoint.y;
      }
    }
  };

  initPoint = (point, layout = 'white-circle') => {
    point.init(this);
    point.layout = layout;
  };

  getOffset = () => {
    return this.line.getOffset();
  };

  moveMitered = (xDiff = 0, yDiff = 0) => {
    for (let miteredPoint of this.miteredPoints ) {
      miteredPoint.x -= xDiff;
      miteredPoint.y -= yDiff;
    }
    this.heightNumberText.pos.x -= xDiff;
    this.heightNumberText.pos.y -= yDiff;
    for (let segment of this._segments ) {
      segment.length.pos.x -= xDiff;
      segment.length.pos.y -= yDiff;
      if (segment.thickness) {
        segment.thickness.pos.x -= xDiff;
        segment.thickness.pos.y -= yDiff;
      }
    }
  };

  setNewLineWidth = () => {
    this.updateCornerPoints();
    this.updateSectionHeightPos();
    this.updateSegmentsLength();
    this.updateSegmentThicknessPos();
  };

  updateCornerPoints = () => {
    this.miteredPoints[0].x = this.line.from.x
    this.miteredPoints[0].y = this.line.from.y
    this.miteredPoints[this.miteredPoints.length - 1].x = this.line.to.x
    this.miteredPoints[this.miteredPoints.length - 1].y = this.line.to.y
  };

  updateSectionHeightPos = () => {
    const midPoint = getMidPoint(this.line.from, this.line.to);
    this.heightNumberText.pos.x = midPoint.x;
    this.heightNumberText.pos.y = midPoint.y;
  };

  updateSegmentsLength = () => {
    for (let segmentIndex in this._segments ) {
      if (this._segments.hasOwnProperty(segmentIndex)) {
        const midPoint = getMidPoint(this.miteredPoints[+segmentIndex], this.miteredPoints[+segmentIndex + 1]);
        let length = getPointDistance(this.miteredPoints[+segmentIndex], this.miteredPoints[+segmentIndex + 1]);
        this._segments[+segmentIndex].length.pos.x = midPoint.x;
        this._segments[+segmentIndex].length.pos.y = midPoint.y;
        this._segments[+segmentIndex].length.value = length;
        this.setSegmentLength(length, this._segments[segmentIndex], this);
      }
    }
  };

  updateSegmentThicknessPos = () => {
    for (let segmentIndex in this._segments ) {
      if (this._segments.hasOwnProperty(segmentIndex) && this.miteredPoints[+segmentIndex + 1]) {
        const midPoint = getMidPoint(this.miteredPoints[+segmentIndex], this.miteredPoints[+segmentIndex + 1]);
        if (this._segments[+segmentIndex].thickness) {
          this._segments[+segmentIndex].thickness.pos.x = midPoint.x;
          this._segments[+segmentIndex].thickness.pos.y = midPoint.y;
        }
      }
    }
  };

  setSegmentLengthFromNumberValue = (value, numberText) => {
    value = Math.round10(+value / Config.getMeasureMultiplier(), -3);
    let miteredSection = numberText.parent;
    let miteredSegments = miteredSection.getSegments();
    let miteredSegment = miteredSegments.find(seg => seg.length === numberText);

    this.setSegmentLength(value, miteredSegment, miteredSection);
  };

  setSegmentLength = (value, segment, miteredSection) => {
    // resize line if there is only one section
    if (this._segments.length === 1 && !this.isResizingParentLine) {
      this.isResizingParentLine = true;
      try {
        setLineWidth(value, this.line);
      } finally {
        this.isResizingParentLine = false;
      }
      return;
    }

    //update segment and maxSegment priority
    segment.setPriority(++this.state.maxSegmentPriority);
    this.resizeMiteredSegment(value, segment);

    // we need to recreate slab shape so we delete existing it
    sqftSlabManager.deleteSlabBacksplashByLine(this.line);
    if (this.type === MITERED_OVERLAY_TYPE.mitered) {
      workspace.miteredController.updateSection(miteredSection);
    } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
      workspace.underlaymentController.updateSection(miteredSection);
    }
  };

  setSegmentHeightFromNumberValue = (value, numberText) => {
    const newValue = +value
    let miteredSection = numberText.parent;
    this.setSegmentHeight(newValue, miteredSection);
  };

  setSegmentHeight = (newValue, miteredSection) => {
    let segments = miteredSection.getSegments();
    sqftConfig.measureUnit === "Metric"
      ? miteredSection.state.heightMetric = newValue
      : miteredSection.state.height = newValue;

    miteredSection.heightNumberText.value = newValue;
    segments.map((segment) => {
      segment.height = newValue
    });

    // we need to recreate slab shape so we delete existing it
    sqftSlabManager.deleteSlabBacksplashByLine(this.line);
    if (this.type === MITERED_OVERLAY_TYPE.mitered) {
      workspace.miteredController.updateSection(miteredSection);
    } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
      workspace.underlaymentController.updateSection(miteredSection);
    }
  }

  setSegmentThicknessFromNumberValue = (value, numberText) => {
    const newValue = +value
    let miteredSection = numberText.parent;
    let miteredSegments = miteredSection.getSegments();
    let miteredSegment = miteredSegments.find(seg => seg.thickness === numberText);

    this.setSegmentThickness(newValue, miteredSegment, miteredSection);
    if (this.type === MITERED_OVERLAY_TYPE.mitered) {
      workspace.miteredController.updateSection(miteredSection);
    } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
      workspace.underlaymentController.updateSection(miteredSection);
    }
  };

  setSegmentThickness = (newValue, miteredSegment, miteredSection) => {
    sqftConfig.measureUnit === "Metric"
      ? miteredSection.state.thicknessMetric = newValue
      : miteredSection.state.thickness = newValue;
    miteredSegment.thickness.value = newValue;

    if (this.type === MITERED_OVERLAY_TYPE.mitered) {
      workspace.miteredController.updateSection(miteredSection);
    } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
      workspace.underlaymentController.updateSection(miteredSection);
    }
  }

  getSegmentByNumberText = (numberText) => {
    let segmentIndex = this._segments.map(seg => seg.length).indexOf(numberText);

    return this._segments[segmentIndex];
  };

  getResizedSegmentsWithoutPriority = (segment) => {
    let segmentIndex = this._segments.indexOf(segment);
    let closestLeft = this._segments[segmentIndex -1 ]
      ? this._segments[segmentIndex -1 ].priority === 0
      : null;
    let closestRight = this._segments[segmentIndex +1 ]
      ? this._segments[segmentIndex +1 ].priority === 0
      : null;

    return {closestLeft, closestRight};
  };

  getResizedSegmentsFreeSpace = (segment) => {
    let segmentIndex = this._segments.indexOf(segment);
    let closestLeft = this._segments[segmentIndex -1 ];
    let closestRight = this._segments[segmentIndex +1 ];

    return {closestLeft, closestRight};
  };

  getResizedSegmentsByPriority = (segment) => {
    let segmentIndex = this._segments.indexOf(segment);
    let minPrevSegment = null;
    let minNextSegment = null;
    if(this._segments[segmentIndex -1 ]) {
      let prevSegments = this._segments.slice(0, segmentIndex);
      minPrevSegment = getMinInArray(prevSegments, 'priority');
    }
    if(this._segments[segmentIndex +1 ]) {
      let nextSegments = this._segments.slice(segmentIndex + 1);
      minNextSegment = getMinInArray(nextSegments.reverse(), 'priority'); // reverse array to get closest element
    }

    return {minPrevSegment, minNextSegment};
  };

  movePointWithMouse = (mousePos, point1) => {
    let scale = workspace.getScale();
    let xDiff = (this.state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (this.state.mouseDownPosition.y - mousePos.y) / scale;

    //debugger
    yDiff = this.getMousePosPointDiff(yDiff, point1, mousePos, true);
    xDiff = this.getMousePosPointDiff(xDiff, point1, mousePos, true);

    this.movePoint(xDiff, yDiff, point1);
    this.moveMeasurements(point1);

    this.state.mouseDownPosition.y = mousePos.y;
    this.state.mouseDownPosition.x = mousePos.x;
  };

  // first resize free space then segments without and with priority
  resizeMiteredSegment = (value, segment) => {
    if (!this.resizeMiteredSegmentFreeSpace(value, segment)){
      if (!this.resizeMiteredSegmentWithoutPriority(value, segment)) {
        this.resizeMiteredSegmentWithPriority(value, segment);
      }
    }
  };

  resizeMiteredSegmentWithPriority = (value, segment) => {
    let yDiff = 0,
      xDiff = 0,
      lineDirection = this.line.getLineDirection(),
      {minPrevSegment, minNextSegment} = this.getResizedSegmentsByPriority(segment),
      segmentIndex = this._segments.indexOf(segment),
      minNextSegmentIndex = this._segments.indexOf(minNextSegment),
      minPrevSegmentIndex = this._segments.indexOf(minPrevSegment),

      [segmentPoint1, segmentPoint2] = this.getSegmentPointsBySegment(segment),
      pointDistance = getPointDistance(segmentPoint1, segmentPoint2);

    // move only to one side with lowest priority
    if (minPrevSegment ? minPrevSegment.priority : 0 > minNextSegment ? minNextSegment.priority : 0) {
      minPrevSegment = null
    } else if(minPrevSegment ? minPrevSegment.priority : 0 < minNextSegment ? minNextSegment.priority : 0) {
      minNextSegment = null
    }

    let moveAllNextPoints = (xDiff, yDiff) => {
      let index = segmentIndex;
      while(minNextSegmentIndex > index) {
        let [segmentBetweenPoint1, segmentBetweenPoint2] = this.getSegmentPointsBySegment(this._segments[index]);
        this.movePoint(xDiff, yDiff, segmentBetweenPoint2, true);
        this.moveMeasurements(segmentBetweenPoint2);
        index++

        void segmentBetweenPoint1;
      }
    };

    let moveAllPrevPoints = (xDiff, yDiff) => {
      let index = segmentIndex;
      while(minPrevSegmentIndex < index) {
        let [segmentBetweenPoint1, segmentBetweenPoint2] = this.getSegmentPointsBySegment(this._segments[index]);
        this.movePoint(xDiff, yDiff, segmentBetweenPoint1, true);
        this.moveMeasurements(segmentBetweenPoint1);
        index--

        void segmentBetweenPoint2;
      }
    };
    switch(this.line.getOrientation()) {
      case orientation.HORIZONTAL:
        if (minPrevSegment && minNextSegment) {
          xDiff = lineDirection.newDirection === "east" ? value - pointDistance: -value + pointDistance;
          moveAllPrevPoints(xDiff / 2);

          xDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          moveAllNextPoints(xDiff / 2);
        } else if(minPrevSegment && !minNextSegment) {
          xDiff = lineDirection.newDirection === "east" ? value - pointDistance: -value + pointDistance;
          moveAllPrevPoints(xDiff);
        } else if(!minPrevSegment && minNextSegment) {
          xDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          moveAllNextPoints(xDiff);
        }

        break;
      case orientation.VERTICAL:
        if (minPrevSegment && minNextSegment) {
          yDiff = lineDirection.newDirection === "east" ? value - pointDistance : -value + pointDistance;
          moveAllPrevPoints(xDiff, yDiff / 2);

          yDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          moveAllNextPoints(xDiff, yDiff / 2);
        } else if(minPrevSegment && !minNextSegment) {
          yDiff = lineDirection.newDirection === "east" ? value - pointDistance : -value + pointDistance;
          moveAllPrevPoints(xDiff, yDiff);
        } else if(!minPrevSegment && minNextSegment) {
          yDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          moveAllNextPoints(xDiff, yDiff);
        }
        break;
      case orientation.NORTHWEST:
      case orientation.SOUTHEAST:
        break;
      case orientation.NORTHEAST:
      case orientation.SOUTHWEST:
        break;
    }
  };

  resizeMiteredSegmentWithoutPriority = (value, segment) => {
    let {closestLeft, closestRight} = this.getResizedSegmentsWithoutPriority(segment);
    //resize segments only if they are without priority
    if(!closestLeft && !closestRight) {
      return false
    }

    let yDiff = 0,
      xDiff = 0,
      lineDirection = this.line.getLineDirection(),
      [segmentPoint1, segmentPoint2] = this.getSegmentPointsBySegment(segment),
      pointDistance = getPointDistance(segmentPoint1, segmentPoint2);

    switch(this.line.getOrientation()) {
      case orientation.HORIZONTAL:
        if(closestLeft && closestRight) {
          xDiff = lineDirection.newDirection === "east" ? value - pointDistance: -value + pointDistance;
          this.movePoint(xDiff / 2, yDiff, segmentPoint1, true);
          this.moveMeasurements(segmentPoint1);

          xDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          this.movePoint(xDiff / 2, yDiff, segmentPoint2, true);
          this.moveMeasurements(segmentPoint2);

        } else if(closestLeft && !closestRight) {
          xDiff = lineDirection.newDirection === "east" ? value - pointDistance: -value + pointDistance;
          this.movePoint(xDiff, yDiff, segmentPoint1, true);
          this.moveMeasurements(segmentPoint1);

        } else if(!closestLeft && closestRight) {
          xDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
          this.movePoint(xDiff, yDiff, segmentPoint2, true);
          this.moveMeasurements(segmentPoint2);
        }

        break;
      case orientation.VERTICAL:
        if(closestLeft && closestRight) {
          yDiff = lineDirection.newDirection === "north" ? -value + pointDistance: value - pointDistance;
          this.movePoint(xDiff / 2, yDiff, segmentPoint1, true);
          this.moveMeasurements(segmentPoint1);

          yDiff = lineDirection.newDirection === "north" ? value - pointDistance : -value + pointDistance;
          this.movePoint(xDiff / 2, yDiff, segmentPoint2, true);
          this.moveMeasurements(segmentPoint2);

        } else if(closestLeft && !closestRight) {
          yDiff = lineDirection.newDirection === "north" ? -value + pointDistance: value - pointDistance;
          this.movePoint(xDiff, yDiff, segmentPoint1, true);
          this.moveMeasurements(segmentPoint1);

        } else if(!closestLeft && closestRight) {
          yDiff = lineDirection.newDirection === "north" ? value - pointDistance : -value + pointDistance;
          this.movePoint(xDiff, yDiff, segmentPoint2, true);
          this.moveMeasurements(segmentPoint2);
        }
        break;
      case orientation.NORTHWEST:
      case orientation.SOUTHEAST:
        break;
      case orientation.NORTHEAST:
      case orientation.SOUTHWEST:
        break;
    }

    return true
  };

  resizeMiteredSegmentFreeSpace = (value, segment) => {
    let {closestLeft, closestRight} = this.getResizedSegmentsFreeSpace(segment);
    //if segments exist skip resizing
    if (!closestLeft || !closestRight) {
      let yDiff = 0,
        xDiff = 0,
        lineDirection = this.line.getLineDirection(),
        [segmentPoint1, segmentPoint2] = this.getSegmentPointsBySegment(segment),
        [smallestLinePoint, biggestLinePoint] = this.line.getLinePointsWithoutCorners(),
        pointDistance = getPointDistance(segmentPoint1, segmentPoint2);

      // todo move skip into function
      switch(this.line.getOrientation()) {
        case orientation.HORIZONTAL:
          if(!closestLeft && closestRight) {
            xDiff = lineDirection.newDirection === "east" ? value - pointDistance: -value + pointDistance;
            // skip if there is no whitespace
            if(lineDirection.newDirection === "east" ){
              if(segmentPoint1.x - xDiff <= smallestLinePoint.x || segmentPoint1.x === smallestLinePoint.x){
                return false
              } else if(Math.round(segmentPoint1.x) === smallestLinePoint.x){
                segmentPoint1.x = smallestLinePoint.x;
                return false
              }
            } else {
              if(segmentPoint1.x - xDiff >= biggestLinePoint.x || segmentPoint1.x === biggestLinePoint.x){
                return false
              } else if(Math.round(segmentPoint1.x) === biggestLinePoint.x){
                segmentPoint1.x = biggestLinePoint.x;
                return false
              }
            }
            this.movePoint(xDiff, yDiff, segmentPoint1, true);
            this.moveMeasurements(segmentPoint1);

          } else if(closestLeft && !closestRight) {
            xDiff = lineDirection.newDirection === "east" ? -value + pointDistance: value - pointDistance;
            if(lineDirection.newDirection === "east" ){
              if(segmentPoint2.x - xDiff >= biggestLinePoint.x){
                return false
              } else if(Math.round(segmentPoint2.x) === biggestLinePoint.x){
                segmentPoint2.x = biggestLinePoint.x;
                return false
              }
            } else {
              if(segmentPoint2.x - xDiff <= smallestLinePoint.x){
                return false
              } else if(Math.round(segmentPoint2.x) === smallestLinePoint.x){
                segmentPoint2.x = smallestLinePoint.x;
                return false
              }
            }
            this.movePoint(xDiff, yDiff, segmentPoint2, true);
            this.moveMeasurements(segmentPoint2);
          }

          break;
        case orientation.VERTICAL:
          if(!closestLeft && closestRight) {
            yDiff = lineDirection.newDirection === "north" ? -value + pointDistance: value - pointDistance;
            // skip if there is no whitespace
            if(lineDirection.newDirection === "north" ){
              if(segmentPoint1.y - yDiff >= biggestLinePoint.y){
                return false
              } else if(Math.round(segmentPoint1.y) === biggestLinePoint.y){
                segmentPoint1.y = biggestLinePoint.y;
                return false
              }
            } else {
              if(segmentPoint1.y - yDiff <= smallestLinePoint.y){
                return false
              } else if(Math.round(segmentPoint1.y) === smallestLinePoint.y){
                segmentPoint1.y = smallestLinePoint.y;
                return false
              }
            }
            this.movePoint(xDiff, yDiff, segmentPoint1, true);
            this.moveMeasurements(segmentPoint1);

          } else if(closestLeft && !closestRight) {
            yDiff = lineDirection.newDirection === "north" ? value - pointDistance : -value + pointDistance;
            // skip if there is no whitespace and fix round position
            if(lineDirection.newDirection === "north" ){
              if(segmentPoint2.y - yDiff <= smallestLinePoint.y){
                return false
              } else if(Math.round(segmentPoint2.y) === smallestLinePoint.y){
                segmentPoint2.y = smallestLinePoint.y;
                return false
              }
            } else {
              if(segmentPoint2.y - yDiff >= biggestLinePoint.y){
                return false
              } else if(Math.round(segmentPoint2.y) === biggestLinePoint.y){
                segmentPoint2.y = biggestLinePoint.y;
                return false
              }
            }
            this.movePoint(xDiff, yDiff, segmentPoint2, true);
            this.moveMeasurements(segmentPoint2);
          }
          break;
        case orientation.NORTHWEST:
        case orientation.SOUTHEAST:
          break;
        case orientation.NORTHEAST:
        case orientation.SOUTHWEST:
          break;
      }
    }

    return false
  };

  /**
   * @deprecated
   */
  getLeftRightStopPoint = (point1) => {
    let o = this.line.getOrientation(),
      lineDirection = this.line.getLineDirection(),
      toCornerLength = this.line.to.getArcLength() || this.line.get45CornerLegDistance(),
      prevLine = this.line.getParent().getPrevLine(this.line),
      fromCornerLength = prevLine.to.getArcLength() || prevLine.get45CornerLegDistance(),
      toCornerMargin = 0,
      fromCornerMargin = 0,
      axis = null,
      index = this.miteredPoints.indexOf(point1),
      stopPointLeft = null,
      stopPointRight = null,
      biggestLinePoint = null,
      smallestLinePoint = null;

    if (o === orientation.VERTICAL) {
      toCornerMargin = lineDirection.newDirection === "north" ? -fromCornerLength : -toCornerLength;
      fromCornerMargin = lineDirection.newDirection === "north" ? +toCornerLength : +fromCornerLength;
      biggestLinePoint = this.line.getBiggestYPoint().y + toCornerMargin;
      smallestLinePoint = this.line.getSmallestYPoint().y + fromCornerMargin;
      axis = y;
    } else if(o === orientation.HORIZONTAL) {
      toCornerMargin = lineDirection.newDirection === "east" ? -toCornerLength : -fromCornerLength;
      fromCornerMargin = lineDirection.newDirection === "east" ? +fromCornerLength : +toCornerLength;
      biggestLinePoint = this.line.getBiggestXPoint().x + toCornerMargin;
      smallestLinePoint = this.line.getSmallestXPoint().x + fromCornerMargin;
      axis = x;
    } else {
      //todo
    }

    void axis; void biggestLinePoint; void smallestLinePoint;
    void index; void stopPointLeft; void stopPointRight;
  };

  movePoint = (xDiff, yDiff, point1, moveStopPoints = false) => {
    let o = this.line.getOrientation(),
      lineDirection = this.line.getLineDirection(),
      // toCornerLength = this.line.to.getArcLength() || this.line.get45CornerLegDistance(),
      // prevLine = this.line.getParent().getPrevLine(this.line),
      // fromCornerLength = prevLine.to.getArcLength() || prevLine.get45CornerLegDistance(),
      pointIndex = this.miteredPoints.indexOf(point1),
      //toCornerMargin = 0,
      //fromCornerMargin = 0,
      stopPointLeft = null,
      stopPointRight = null,
      smallestPointStopped = null,
      biggestPointStopped = null,
      biggestLinePoint = null,
      smallestLinePoint = null
    ;

    //do'nt move first and las point
    if (pointIndex === 0 || pointIndex === this.miteredPoints.length - 1) {
      return []
    }

    if (o === orientation.VERTICAL) {
      //line biggest and smallest points
      biggestLinePoint = Object.assign({}, this.line.getBiggestYPoint().pos);
      smallestLinePoint = Object.assign({}, this.line.getSmallestYPoint().pos);
      // stop point on overline move
      if (lineDirection.newDirection === "north" ) {
        //toCornerMargin = -fromCornerLength;
        //fromCornerMargin = +toCornerLength;
        //biggestLinePoint.y += toCornerMargin;
        //smallestLinePoint.y += fromCornerMargin;
        stopPointLeft = this.miteredPoints[pointIndex + 1] ? this.miteredPoints[pointIndex + 1] : smallestLinePoint;
        stopPointRight = this.miteredPoints[pointIndex - 1] ? this.miteredPoints[pointIndex - 1] : biggestLinePoint;
      } else {
        //toCornerMargin = -toCornerLength;
        //fromCornerMargin = +fromCornerLength;
        //biggestLinePoint.y += toCornerMargin;
        //smallestLinePoint.y += fromCornerMargin;
        stopPointLeft = this.miteredPoints[pointIndex - 1] ? this.miteredPoints[pointIndex - 1] : smallestLinePoint;
        stopPointRight = this.miteredPoints[pointIndex + 1] ? this.miteredPoints[pointIndex + 1] : biggestLinePoint;
      }

      [smallestPointStopped, biggestPointStopped] = this.movePointInOrStop(
        point1, 'y', yDiff,
        biggestLinePoint.y,
        smallestLinePoint.y,
        stopPointLeft,
        stopPointRight,
        moveStopPoints
      );
    } else if (o === orientation.HORIZONTAL) {
      //line biggest and smallest points
      biggestLinePoint = Object.assign({}, this.line.getBiggestXPoint().pos);
      smallestLinePoint = Object.assign({}, this.line.getSmallestXPoint().pos);
      // stop point on overline move if it is not mitered then it should'nt go overline
      if (lineDirection.newDirection === "east" ) {
        //toCornerMargin = -toCornerLength;
        //fromCornerMargin = +fromCornerLength;
        //biggestLinePoint.x += toCornerMargin;
        //smallestLinePoint.x += fromCornerMargin;
        stopPointLeft = this.miteredPoints[pointIndex - 1] ? this.miteredPoints[pointIndex - 1] : smallestLinePoint;
        stopPointRight = this.miteredPoints[pointIndex + 1] ? this.miteredPoints[pointIndex + 1] : biggestLinePoint;
      } else {
        //toCornerMargin = -fromCornerLength;
        //fromCornerMargin = +toCornerLength;
        //biggestLinePoint.x += toCornerMargin;
        //smallestLinePoint.x += fromCornerMargin;
        stopPointLeft = this.miteredPoints[pointIndex + 1] ? this.miteredPoints[pointIndex + 1] : smallestLinePoint;
        stopPointRight = this.miteredPoints[pointIndex - 1] ? this.miteredPoints[pointIndex - 1] : biggestLinePoint;
      }
      // stop point on overline move
      [smallestPointStopped, biggestPointStopped] = this.movePointInOrStop(
        point1, 'x', xDiff,
        biggestLinePoint.x,
        smallestLinePoint.x,
        stopPointLeft,
        stopPointRight,
        moveStopPoints
      );
    } else {
      //todo rotation
      // const nextLine = parent.getNextLine(self);
      // const prevLine = parent.getPrevLine(self);
      // moveDiagonalLine(self, nextLine, prevLine, this.state.movePointDistance, yDiff, o);
      // this.state.mouseDownPosition = mousePos;
    }

    return [smallestPointStopped, biggestPointStopped]
    // self.from = lockPointToCanvas(self.from);  //  removed locking because of this issue http://jira.mozidev.com/browse/QC-802
    // self.to = lockPointToCanvas(self.to);
  };

  render = (ctx) => {
    if (isDisabledInPopupShouldBeHidden() && isDisabledInPopupWithParents(this)) {
      return
    }
    this.renderTopBlueLine(ctx);
    this.renderRuler(ctx);
    this.renderLetter(ctx);
    //this.renderThickness(ctx);
    this.renderHeight(ctx);
    this.renderSectionIndex(ctx);
    // this.renderMeasurements(ctx);
  };

  //blue line between middle points
  renderTopBlueLine = (ctx) => {
    let renderFrom = this.line.calculateRenderPosition(this.miteredPoints[0]),
      renderTo = this.line.calculateRenderPosition(this.miteredPoints[this.miteredPoints.length - 1]);

    ctx.beginPath();
    ctx.moveTo(renderFrom.x, renderFrom.y);
    ctx.lineTo(renderTo.x, renderTo.y);
    ctx.lineWidth = 8;
    if(EventManager.getCursor().indexOf("delete") >= 0 && this.line.isHovering() && !this.state.isHoveringPoint) {
      ctx.strokeStyle = this.design.deleteFillStyle;
    } else {
      ctx.strokeStyle = this.design.lineTextColor;
    }
    ctx.stroke();
    ctx.closePath();
  };

  renderRuler = (ctx) => {
    const pointsToRender = this.miteredPoints.map((point) => {
      return this.line.calculateRenderPosition(point);
    });

    ctx.beginPath();
    pointsToRender.forEach((point, index) => {
      let next = index + 1;
      if (pointsToRender[next]) {
        const [parallelPointFrom, parallelPointTo] = getParallelPoints(point, pointsToRender[next], -this.design.rulerMargin);
        this.drawArrow( ctx,
          parallelPointFrom.x,
          parallelPointFrom.y,
          parallelPointTo.x,
          parallelPointTo.y
        );
      }
    });

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  // text is rendered from number text
  renderHeight = (ctx) => {
    let [fromPointWithIndent, toPointWithIndent] = this.line.getLinePointsWithoutCorners(),
      renderFrom = getPointField(fromPointWithIndent.x, fromPointWithIndent.y, this),
      renderTo = getPointField(toPointWithIndent.x, toPointWithIndent.y, this);

    ctx.beginPath();

    const [parallelPointFrom, parallelPointTo] = getParallelPoints(renderFrom, renderTo, -this.design.heightMargin);
    this.drawFlatArrow( ctx,
      parallelPointFrom.x,
      parallelPointFrom.y,
      parallelPointTo.x,
      parallelPointTo.y
    );

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  renderLetter = (ctx) => {
    let fontHeight = this.design.fontHeight,
      font = fontHeight + "px " + this.design.fontFamily;

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = this.design.fontColor;

    const pointsToRender = this.miteredPoints.map((point) => {
      return this.line.calculateRenderPosition(point);
    });

    pointsToRender.forEach((point, index) => {
      let next = index + 1;
      if (pointsToRender[next]) {
        const [parallelPointFrom, parallelPointTo] = getParallelPoints(point, pointsToRender[next], -this.design.letterMargin);
        let letter = numToLetter(next);
        let midPoint = getMidPoint(parallelPointFrom, parallelPointTo);
        let mText = ctx.measureText(letter);
        ctx.wrapText(letter, midPoint.x, midPoint.y, mText, fontHeight);
      }
    });

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  renderThickness = (ctx) => {
    let lineDirection = this.line.getLineDirection(),
      fontHeight = this.design.fontHeight,
      font = fontHeight + "px " + this.design.fontFamily,
      xMarginLine = 0,
      yMarginLine = 0,
      xMarginImage = 0,
      yMarginImage = 0,
      xMarginValue = 0,
      yMarginValue = 0,
      pointField = {};
    void xMarginValue;
    void yMarginValue;

    switch (lineDirection.orientation) {
      case "horizontal": {
        yMarginLine = (lineDirection.newDirection === "west" ? this.design.thicknessMargin : -this.design.thicknessMargin);

        xMarginImage = (lineDirection.newDirection === "east" ? -20 : -20);
        yMarginImage = (lineDirection.newDirection === "east" ? 0 : -30);

        xMarginValue = (lineDirection.newDirection === "east" ? 15 : 15);
        yMarginValue = (lineDirection.newDirection === "east" ? 16 : -14);

        break;
      }
      case "vertical": {
        xMarginLine = (lineDirection.newDirection === "south" ? this.design.thicknessMargin: -this.design.thicknessMargin);

        xMarginImage = (lineDirection.newDirection === "north" ? 0 : -50);
        yMarginImage = (lineDirection.newDirection === "north" ? -10 : -10);

        xMarginValue = (lineDirection.newDirection === "north" ? 35 : -16);
        yMarginValue = (lineDirection.newDirection === "north" ? 5 : 6);
        break;
      }
      // todo rotation
      case "NORTHWEST": { break;}
      case "NORTHEAST": { break;}
      case "SOUTHWEST": { break;}
      case "SOUTHEAST": { break;}
      default:
        break;
    }

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = this.design.fontColor;

    this.miteredPoints.forEach((point, index) => {
      let next = index + 1;
      if(this.miteredPoints[next]) {
        let midPoint = getMidPoint(
          this.line.calculateRenderPosition(point),
          this.line.calculateRenderPosition(this.miteredPoints[next])
        );
        let segment = this.getSegmentBetweenPoints(point, this.miteredPoints[next]);
        let thicknessValue = segment.thickness.value;
        let mText = ctx.measureText(thicknessValue.toString());

        void mText;
        //debugger
        pointField.x = midPoint.x + xMarginLine;
        pointField.y = midPoint.y + yMarginLine;

        // blue line
        ctx.moveTo(pointField.x, pointField.y);
        ctx.lineTo(pointField.x - xMarginLine, pointField.y - yMarginLine);

        // thickness image
        DrawImage.renderImage('thickness', ctx,
          pointField.x + xMarginImage,
          pointField.y + yMarginImage,
          8,
          8,
          true,
          true
        );

        // thickness value rendered from NumberText
        // ctx.wrapText(
        //   thicknessValue.toString(),
        //   pointField.x + xMarginValue,
        //   pointField.y + yMarginValue,
        //   mText,
        //   fontHeight
        // );
      }
    });

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  renderSectionIndexOld = (ctx) => {
    let lineDirection = this.line.getLineDirection(),
      renderTo  = this.line.calculateRenderPosition(this.line.to),
      renderFrom = this.line.calculateRenderPosition(this.line.from),
      fontHeight = this.design.fontHeight - 3,
      font = fontHeight + "px " + this.design.fontFamily,
      xMargin = 0,
      yMargin = 0,
      xOffset = 15,
      yOffset = 15,
      xWidth = 0,
      yWidth = 0,
      xMarginValue = 0,
      yMarginValue = 0,
      renderPos;

    const scale = Config.scale;
    let text = ('0' + this.sectionIndex).slice(-2);
    let mText = ctx.measureText(text);

    void xMargin;
    void yMargin;
    void scale;
    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = this.design.fontColor;

    switch (lineDirection.orientation) {
      case "horizontal": {
        //measurement arrow offset
        yWidth = -this.design.sectionArrowWidth / 2;
        yMargin = (lineDirection.newDirection === "east" ? -this.design.sectionArrowWidth : this.design.sectionArrowWidth);
        yOffset = 0;

        // text and value
        xMarginValue = (lineDirection.newDirection === "east" ? -this.design.sectionIndexMargin: -this.design.sectionIndexMargin);
        renderPos = (lineDirection.newDirection === "east" ? renderFrom: renderTo);

        //render double circle
        RenderFigures.renderDoubleCircle(ctx, {x: renderPos.x + xMarginValue, y: renderPos.y + yMarginValue }, 12, 2);

        //render value
        ctx.save();
        ctx.translate(renderPos.x + xMarginValue, renderPos.y + yMarginValue);
        ctx.rotate(-Math.PI / 2);
        ctx.fillStyle = "#fff";
        ctx.wrapText(text, 2,  4, mText, fontHeight); // (text, x,  y - additional offset
        ctx.restore();
        break;
      }
      case "vertical": {
        //measurement arrow offset
        xWidth = -this.design.sectionArrowWidth / 2;
        xMargin = (lineDirection.newDirection === "north" ? -this.design.sectionIndexMargin: this.design.sectionIndexMargin);
        xOffset = 0;

        // text and value
        yMarginValue = (lineDirection.newDirection === "north" ? -this.design.sectionIndexMargin : -this.design.sectionIndexMargin);
        renderPos = (lineDirection.newDirection === "north" ? renderTo: renderFrom);

        //render double circle
        RenderFigures.renderDoubleCircle(ctx,
          {x: renderPos.x + xMarginValue, y: renderPos.y + yMarginValue },
          12,
          2
        );

        //render value
        ctx.fillStyle = "#fff";
        // (text, +1,  +4 - additional number offset
        ctx.wrapText(text, renderPos.x + xMarginValue + 1, renderPos.y + yMarginValue + 4, mText, fontHeight);
        break;
      }
      // todo rotation
      case "NORTHWEST": { break;}
      case "NORTHEAST": { break;}
      case "SOUTHWEST": { break;}
      case "SOUTHEAST": { break;}
      default:
        break;
    }

    //render measurement arrow
    this.drawFlatArrow( ctx,
      renderPos.x + xMarginValue - xWidth + xOffset,
      renderPos.y + yMarginValue - yWidth + yOffset,
      renderPos.x + xMarginValue + xWidth + xOffset,
      renderPos.y + yMarginValue + yWidth + yOffset
    );

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  renderSectionIndex = (ctx) => {
    let lineDirection = this.line.getLineDirection(),
      midPoint = getMidPoint(this.line.to, this.line.from),
      fontHeight = this.design.fontHeight - 3,
      font = fontHeight + "px " + this.design.fontFamily,
      xMarginValue = 0,
      yMarginValue = 0,
      renderPos = this.line.calculateRenderPosition({
        pos: {x: midPoint.x, y: midPoint.y}
      });

    const scale = Config.scale;
    void scale;

    let text = ('0' + this.sectionIndex).slice(-2);
    let mText = ctx.measureText(text);

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = this.design.fontColor;

    switch (lineDirection.orientation) {
      case "horizontal": {
        // text and value
        yMarginValue = (lineDirection.newDirection === "east" ? -this.design.sectionIndexMargin: this.design.sectionIndexMargin);

        //render double circle
        RenderFigures.renderDoubleCircle(ctx, {x: renderPos.x + xMarginValue, y: renderPos.y + yMarginValue }, 12, 2);

        //render value
        ctx.fillStyle = "#fff";
        // (text, +1,  +4 - additional number offset
        ctx.wrapText(text, renderPos.x + xMarginValue + 1, renderPos.y + yMarginValue + 4, mText, fontHeight);
        break;
      }
      case "vertical": {
        // text and value
        xMarginValue = (lineDirection.newDirection === "north" ? -this.design.sectionIndexMargin : this.design.sectionIndexMargin + fontHeight);

        //render double circle
        RenderFigures.renderDoubleCircle(ctx, {x: renderPos.x + xMarginValue, y: renderPos.y + yMarginValue }, 12, 2);

        //render value
        ctx.save();
        ctx.translate(renderPos.x + xMarginValue, renderPos.y + yMarginValue);
        ctx.rotate(-Math.PI / 2);
        ctx.fillStyle = "#fff";
        ctx.wrapText(text, 2,  4, mText, fontHeight); // (text, x,  y - additional offset
        ctx.restore();
        break;
      }
      // todo rotation
      case "NORTHWEST": { break;}
      case "NORTHEAST": { break;}
      case "SOUTHWEST": { break;}
      case "SOUTHEAST": { break;}
      default:
        break;
    }

    ctx.lineWidth = 1;
    ctx.strokeStyle = this.design.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  };

  drawArrow = (context, fromX, fromY, toX, toY) => {
    let headLen = 10, // length of head in pixels
      dx = toX - fromX,
      dy = toY - fromY,
      angle = Math.atan2(dy, dx);

    context.moveTo(fromX, fromY);
    context.lineTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle - Math.PI / 6), toY - headLen * Math.sin(angle - Math.PI / 6));
    context.moveTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle + Math.PI / 6), toY - headLen * Math.sin(angle + Math.PI / 6));

    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle - Math.PI / 6), fromY + headLen * Math.sin(angle - Math.PI / 6));
    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle + Math.PI / 6), fromY + headLen * Math.sin(angle + Math.PI / 6));
  };

  drawFlatArrow = (context, fromX, fromY, toX, toY) => {
    let headLen = 5, // length of head in pixels
      dx = toX - fromX,
      dy = toY - fromY,
      angle = Math.atan2(dy, dx);

    context.moveTo(fromX, fromY);
    context.lineTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle - Math.PI / 2), toY - headLen * Math.sin(angle - Math.PI / 2));
    context.moveTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle + Math.PI / 2), toY - headLen * Math.sin(angle + Math.PI / 2));

    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle - Math.PI / 2), fromY + headLen * Math.sin(angle - Math.PI / 2));
    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle + Math.PI / 2), fromY + headLen * Math.sin(angle + Math.PI / 2));
  };

  onMouseMove = (mousePos, e) => {
    void e;
    for (const point of this.miteredPoints)  {
      if(this.isMouseOverPoint(mousePos, point)) {
        if (this.state.mouseDown) {
          this.movePointWithMouse(mousePos, point);
          if (this.type === MITERED_OVERLAY_TYPE.mitered) {
            workspace.miteredController.updateSection(this);
          } else if (this.type === MITERED_OVERLAY_TYPE.underlayment) {
            workspace.underlaymentController.updateSection(this);
          }
        }

        return this.state.mouseDown;
      }
    }
  };

  isMouseOverPoint = (mousePos, point) => {
    this.state.isHoveringPoint = !!point.isOverPointField();
    // console.log("point", point.id);
    // console.log("this.state.hoveredPoint", this.state.hoveredPoint.id);
    // console.log("mousePos", this.state.isHoveringPoint);
    return this.state.isHoveringPoint || this.state.mouseDown && this.state.hoveredPoint && point.id === this.state.hoveredPoint.id;
  };

  onMouseUp = (mousePos, e) => {
    void mousePos;
    void e;
    if(this.state.mouseDown) {
      this.state.mouseDown = false;
      this.state.mouseDownPosition = null;
    }
  };

  onMouseDown = (mousePos, e) => {
    void e;
    const reduxState = store.getState();
    const menuOpened = reduxState.sqftMenuState.menuOpened;
    const activeButton = reduxState.sqftMenuState.activeButton;

    if (activeButton === SIDEBAR_NAVIGATION_BUTTONS.edge
      || activeButton === SIDEBAR_BUTTONS_MENU.delete
    ) {
      //do nothing if we want to remove or add edge
    } else if (this.state.isHoveringPoint) {
      this.state.mouseDown = true;
      // this.state.movePointDistance = getPointDistance(this.from, this.to);
      //todo move point
      this.state.mouseDownPosition = mousePos;
      for (const point in this.miteredPoints) {
        if (this.miteredPoints[point].isOverPointField(mousePos)) {
          this.state.hoveredPoint = this.miteredPoints[point]
        }
      }

      return true;
    } else if (this.line.isHovering() && menuOpened === SIDEBAR_NAVIGATION_BUTTONS.mitered)  {
      //console.log('line is hovering');
      let [closest, secondPoint, isPrev] = this.getPointBetweenCords(mousePos);
      let newPoint = this.addPointBetweenPoints(closest, secondPoint, isPrev);
      if (isPrev) {
        this.addMeasurementBetweenPoints(newPoint, secondPoint);
        this.addMeasurementBetweenPoints(closest, newPoint);
      } else {
        this.addMeasurementBetweenPoints(closest, newPoint);
        this.addMeasurementBetweenPoints(newPoint, secondPoint);
      }
      this.removeMeasurementBetweenPoints(closest, secondPoint, isPrev);

      workspace.miteredController.updateSection(this);
      return true;
    }

    return false;
  };

  onMouseLeave = () => {
    this.state.isHoveringPoint = false;
    this.state.mouseDown = false;
    this.state.hoveredPoint = null;
  }
}
